import { styled } from '@creditas-ui/system'

export const Info = styled.div`
  grid-area: info;
`
